export default __webpack_public_path__ + "static/media/CardSim.11c82f64.png";